class ValidationComponent extends HTMLElement {
    constructor(){
        super();
        this.form = this.querySelector('form');
        this.emailEl = this.querySelector('.required-email');
        this.passwordEl = this.querySelector('.required-password');
        this.firstnameEl = this.querySelector('.required-firstname');
        this.lastnameEl = this.querySelector('.required-lastname');
        this.privacyEl = this.querySelector('.required-checkbox');
        this.fieldEl = this.querySelectorAll('.required-field');
        this.countryEl = this.querySelector('.required-country');

        this.hiddenTagInput = this.querySelector("[name='contact[tags]']"); // hidden customer tags input
        if(!this.hiddenTagInput){
            this.addHiddenTagInput();
            this.hiddenTagInput = this.querySelector("[name='contact[tags]']");
        }
        this.profilingEl_array = this.querySelectorAll('.tagging-checkbox'); // checkboxes for customer tags
        this.profilingEl_array.forEach(profilingEl =>
            profilingEl.addEventListener('change', this.manageTags.bind(this))
        );

        this.buttonBack = document.getElementsByClassName('button-cancel');
        this.buttonBackEdit = document.getElementsByClassName('button-cancel-edit');

        this.form.addEventListener('input', this.instantFeedback.bind(this));
        this.form.addEventListener('submit', this.onSubmit.bind(this));

        Array.from(this.buttonBack).forEach(element => element.addEventListener('click', this.restoreFieldValue.bind(this)));
        Array.from(this.buttonBackEdit).forEach(element => element.addEventListener('click', this.restoreFieldValue.bind(this)));

    }

    restoreFieldValue() {
        for (var i = 0; i < this.fieldEl.length; ++i) {
            this.fieldEl[i].value = this.fieldEl[i].defaultValue
            this.showMessage(this.fieldEl[i])
        }
    }

    checkCountry() {
        let valid = false;

        if (!this.countryEl) return true;

        if (this.countryEl !== null) {
            if (this.countryEl.value == '---') {
                this.showMessage(this.countryEl, window.validationString.country);
            } else {
                this.showMessage(this.countryEl)
                valid = true;
            }
        }
        return valid
    }

    checkField() {
        let valid = true;

        if (!this.fieldEl.length) return true;

        if (this.fieldEl[i] !== null) {
            for (var i = 0; i < this.fieldEl.length; ++i) {
                if (this.fieldEl[i].value == '') {
                    this.showMessage(this.fieldEl[i], window.validationString.blank);
                    document.querySelector('.field--error').scrollIntoView({block: "center", behavior: 'smooth'});
                    valid = false;
                } else {
                    this.showMessage(this.fieldEl[i]);
                }
            }
        }

        return valid
    }

    checkPrivacy() {
        let valid = false

        if (!this.privacyEl) return true;

        if (this.privacyEl.checked == false) {
            this.showMessage(this.privacyEl, window.validationString.privacy);
        } else {
            this.showMessage(this.privacyEl);
            valid = true;
        }
        return valid;
    }

    checkEmail() {
        let valid = false;

        if (!this.emailEl) return true;

        if (this.emailEl !== null){
            const email = this.emailEl.value.trim();
            if (!this.isRequired(email)) {
                this.showMessage(this.emailEl, window.validationString.email_blank);
            } else if (!this.isEmailValid(email)) {
                this.showMessage(this.emailEl, window.validationString.email_valid);
            } else{
                this.showMessage(this.emailEl);
                valid = true;
            }
            return valid;
        }
    }

    isEmailValid(email) {
        const re = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return re.test(email);
    }

    checkPassword() {
        let valid = false;

        if (!this.passwordEl) return true;

        if (this.passwordEl !== null) {
            const password = this.passwordEl.value.trim();

            if (!this.isRequired(password)) {
                this.showMessage(this.passwordEl, window.validationString.password_blank);
            } else if (!this.isPasswordValid(password)) {
                this.showMessage(this.passwordEl, window.validationString.password_valid);
            } else {
                this.showMessage(this.passwordEl);
                valid = true;
            }
            return valid;
        }
    }

    isPasswordValid(password) {
        const re = new RegExp("^.{5,}");
        return re.test(password);
    }

    isPasswordSecure(password) {
        const re = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
        return re.test(password);
    }

    checkFirstname() {
        let valid = false;

        if (!this.firstnameEl) return true;

        if (this.firstnameEl !== null){
            const firstname = this.firstnameEl.value.trim();

            if (!this.isRequired(firstname)) {
                this.showMessage(this.firstnameEl, window.validationString.firstname_blank);
            } else {
                this.showMessage(this.firstnameEl);
                valid = true;
            }
        }
        return valid;
    }

    checkLastname() {
        let valid = false;

        if (!this.lastnameEl) return true;

        if (this.lastnameEl !== null){
            const lastname = this.lastnameEl.value.trim();

            if (!this.isRequired(lastname)) {
                this.showMessage(this.lastnameEl, window.validationString.lastname_blank);
            } else {
                this.showMessage(this.lastnameEl);
                valid = true;
            }
        }
        return valid;
    }

    isRequired(value) {
        return value === '' ? false : true;
    }

    showMessage(input, message) {

        const formField = input.parentElement;
        const error = formField.querySelector('small');

        if (!!message){
            formField.classList.add('field--error');
            error.innerHTML = message;
        } else {
            formField.classList.remove('field--error');
            error.innerHTML = '';
        }

    }

    onSubmit(event) {
        let formValidation = false;
        const validateEmail = this.checkEmail();
        const validatePassword = this.checkPassword();
        const validateFirstName = this.checkFirstname();
        const validateLastName = this.checkLastname();
        const validatePrivacy = this.checkPrivacy();
        const validateField = this.checkField();
        const validateCountry = this.checkCountry();
        if(validateEmail && validatePassword && validateFirstName && validateLastName && validatePrivacy && validateField && validateCountry) formValidation = true;

        if (formValidation) {
            if (this.form.getAttribute('data-is-ajax')) {
                event.preventDefault();
                const submitEvent = new Event('validation-submit');
                this.form.dispatchEvent(submitEvent);
            } else {
                return true;
            }
        } else {
            event.preventDefault();
            event.stopImmediatePropagation();
            document.querySelector('.field--error').scrollIntoView({block: "center", behavior: 'smooth'});
        }
    }

    instantFeedback(event) {
        event.preventDefault();
        let e = event.target;
        switch (true) {
            case e.classList.contains("required-email"):
                this.checkEmail();
                break;

            case e.classList.contains("required-password"):
                this.checkPassword();
                break;

            case e.classList.contains("required-firstname"):
                this.checkFirstname();
                break;

            case e.classList.contains("required-lastname"):
                this.checkLastname();
                break;

            case e.classList.contains("required-field"):
                this.checkField();
                break;
        }
    }

    // add/remove tag from hidden input
    manageTags(event){
        const tag_text  = event.currentTarget.getAttribute('data-tag');
        let value_array = this.hiddenTagInput.value.split(',');
        if (event.currentTarget.checked) {
            value_array.push(tag_text);
        } else {
            const index = value_array.indexOf(tag_text);
            if (index > -1) {
                value_array.splice(index, 1);
            }
        }
        let value_array_final     = [...new Set(value_array)].filter(n => n); // array unique and remove empty element
        this.hiddenTagInput.value = value_array_final.join(",");
    }

    // add tag hidden input to form
    addHiddenTagInput(tags=""){ 
        let value_array       = tags.split(',');
        let value_array_final = [...new Set(value_array)].filter(n => n); // array unique and remove empty element
        let hidden_input      = document.createElement("input");
        hidden_input.setAttribute('type', "hidden");
        hidden_input.setAttribute('name', "contact[tags]");
        hidden_input.setAttribute('value', value_array_final.join(","));
        this.form.append(hidden_input);

    }
}

customElements.define('validation-component', ValidationComponent);
